module.exports = __webpack_public_path__ + "img/Bastelstunde.74adea46.jpg";